import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-screen flex items-center justify-center bg-gray-100"
}
const _hoisted_2 = {
  class: "absolute inset-0 flex flex-col justify-between items-center bg-black bg-opacity-80 text-white p-6 md:p-12",
  key: "main-content"
}
const _hoisted_3 = { class: "flex flex-col items-center justify-center mt-16" }
const _hoisted_4 = {
  class: "text-2xl md:text-5xl font-cursive font-black",
  "data-aos": "fade-up",
  "data-aos-delay": "400"
}
const _hoisted_5 = {
  class: "text-md md:text-xl mb-4",
  "data-aos": "fade-up",
  "data-aos-delay": "600"
}
const _hoisted_6 = { class: "flex flex-col items-center mb-40 md:mb-14" }
const _hoisted_7 = { class: "text-center mb-4" }
const _hoisted_8 = {
  class: "text-md md:text-lg",
  "data-aos": "fade-up",
  "data-aos-delay": "1200"
}
const _hoisted_9 = {
  class: "w-full h-full bg-white",
  key: "invitation-content"
}
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_WeddingContent = _resolveComponent("WeddingContent")!
  const _component_LoveContent = _resolveComponent("LoveContent")!
  const _component_WeddingDate = _resolveComponent("WeddingDate")!
  const _component_PhotoGallery = _resolveComponent("PhotoGallery")!
  const _component_BankTransfer = _resolveComponent("BankTransfer")!
  const _component_ReservationForm = _resolveComponent("ReservationForm")!
  const _component_ReservationList = _resolveComponent("ReservationList")!
  const _component_WeddingFooter = _resolveComponent("WeddingFooter")!
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isNotFound)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[1] || (_cache[1] = [
          _createStaticVNode("<div class=\"w-full h-screen flex flex-col items-center justify-center bg-gradient-to-r from-blue-900 to-blue-300 p-8\" data-v-15b5c7ad><div class=\"bg-white rounded-3xl shadow-2xl max-w-md w-full p-12 text-center animate-fadeInUp\" data-v-15b5c7ad><h1 class=\"text-[10rem] font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-900 to-blue-500 select-none\" data-v-15b5c7ad> 404 </h1><h2 class=\"text-3xl font-semibold mb-4 text-gray-800\" data-v-15b5c7ad> Halaman Tidak Ditemukan </h2><p class=\"text-gray-600 leading-relaxed\" data-v-15b5c7ad> Maaf, halaman yang Anda cari tidak tersedia atau telah dipindahkan. </p></div></div>", 1)
        ])))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "relative w-full h-screen flex flex-col bg-cover bg-center",
          style: _normalizeStyle({ backgroundImage: `url(${_ctx.backgroundImage})` })
        }, [
          _createVNode(_Transition, { name: "fade-slide" }, {
            default: _withCtx(() => [
              (!_ctx.showInvitation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _cache[2] || (_cache[2] = _createElementVNode("h1", {
                        class: "text-xl md:text-5xl font-serif mb-2",
                        "data-aos": "zoom-in",
                        "data-aos-delay": "200"
                      }, " The Wedding Of ", -1)),
                      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.brideName) + " & " + _toDisplayString(_ctx.groomName), 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.weddingDate), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[3] || (_cache[3] = _createElementVNode("p", {
                          class: "text-md md:text-lg mb-2",
                          "data-aos": "fade-up",
                          "data-aos-delay": "1000"
                        }, " Kepada Bapak/Ibu/Saudara/i ", -1)),
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.recipientName), 1)
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openInvitation && _ctx.openInvitation(...args))),
                        class: "px-6 py-3 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition flex items-center gap-2",
                        "data-aos": "zoom-in",
                        "data-aos-delay": "1400"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'envelope'] }),
                        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Buka Undangan", -1))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.showInvitation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_WeddingContent),
                    _createVNode(_component_LoveContent),
                    _createVNode(_component_WeddingDate),
                    _createVNode(_component_PhotoGallery),
                    _createVNode(_component_BankTransfer),
                    _createVNode(_component_ReservationForm),
                    _createVNode(_component_ReservationList),
                    _createVNode(_component_WeddingFooter),
                    _createVNode(_component_Navbar)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("audio", {
            ref: "audioElement",
            src: _ctx.backgroundMusicSrc,
            loop: "",
            style: {"display":"none"}
          }, null, 8, _hoisted_10)
        ], 4))
  ]))
}